// extracted by mini-css-extract-plugin
export default {"container":"displayContainer_container__e+W31"};